/* eslint-disable no-unused-vars */
import { Button, Link, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import colors from '../../values/colors';
import values from '../../values/values';
import RowContainerItem from './RowContainerItem';

function InfoCard(props) {
    const paperStyle = { 
        widith: props.widith ? props.widith : 100,
        flex: 1,
        width: '100%',
        boxSizing: 'border-box',
        padding: values.padding[0], 
        ...props.style
    };

    if (props.height != null) {
        paperStyle.height = props.height;
    } else if (paperStyle.height == null && !props.className) {
        paperStyle.height = 105;
    }

    return (        
        <Paper
            className={props.className}
            style={paperStyle}>
            <Stack spacing={values.spacing[0]}>
                <Typography align='center'>{props.title}</Typography>
                <Typography variant="h4" color="primary" align="center">{props.value}</Typography>
            </Stack>
            {props.children}
        </Paper>        
    );
}

export default InfoCard;